import { blockEl, unblockEl } from "./Block";

export default class ReviewFilterImages {
  constructor() {
    this.galleryContains = document.querySelector('.review-image-filter_contains');

    if ( ! this.galleryContains ) {
      return;
    }

    this.galleryContainer = document.querySelector('.review-image-filter');
    this.filterButton = this.galleryContainer.querySelector('.image-filter-btn');

    this.addHandlers();
  }

  addHandlers() {
    this.galleryContains.addEventListener('click', this.onClickFilterButton.bind(this))
  }

  async onClickFilterButton( event ) {
    if (!event.target.classList.contains('image-filter-btn')) {
      return;
    }

    let btn = event.target;
    await this.getReviewFilteredGallery( btn.dataset.more );
  }

  async getReviewFilteredGallery( count ) {
    blockEl( this.galleryContains );

    try {
      let response = await this.getReviewGalleryCounter( count );
      this.updateFilteredGalleryResult( response );
    } catch ( e ) {
      console.error( e );
    } finally {
      unblockEl( this.galleryContains );
    }
  }

  updateFilteredGalleryResult( results ) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(results, 'text/html');

    let galleryContainer = doc.querySelector('.review-image-filter');

    if ( galleryContainer ) {
      this.galleryContainer.replaceWith(galleryContainer);
      this.galleryContainer = galleryContainer;
    }
  }

  async getReviewGalleryCounter( count = 0 ) {
    let uri = new URL(window.location.href);
    let params = new URLSearchParams(uri.search);
    uri.searchParams.set('gallery_page', count);
    params.toString();

    const response = await fetch(uri.href, {
      method: 'GET',
    });

    return await response.text();
  }
}
